var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import BEM from "../bem";
import html from "../htmlTemplateTag";
import "./styles.scss";
var widgetBem = BEM("youtube-video-feed-widget");
var itemBem = BEM("youtube-video-item");
/**
 * The API endpoint for retrieving the most recent videos.
 */
var ENDPOINT = "https://scs-app-backend-481f8.web.app/api/v1/youtube";
var createWidgets = function () {
    "use strict";
    var widgetContainers = widgetBem.select();
    var fetchYoutubeFeed = function () {
        var e_1, _a;
        widgetBem.modify({ state: "loading" });
        try {
            for (var widgetContainers_1 = __values(widgetContainers), widgetContainers_1_1 = widgetContainers_1.next(); !widgetContainers_1_1.done; widgetContainers_1_1 = widgetContainers_1.next()) {
                var widget = widgetContainers_1_1.value;
                widget.innerHTML = html(templateObject_1 || (templateObject_1 = __makeTemplateObject(["<div class=\"", "\">\n        Loading...\n      </div>"], ["<div class=\"", "\">\n        Loading...\n      </div>"])), widgetBem("loading"));
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (widgetContainers_1_1 && !widgetContainers_1_1.done && (_a = widgetContainers_1.return)) _a.call(widgetContainers_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        fetch(ENDPOINT)
            .then(function (data) { return data.json(); })
            .then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
            var videoData;
            return __generator(this, function (_a) {
                videoData = "videos" in response && response.videos ? response.videos : [];
                return [2 /*return*/, videoData.flatMap(function (videoObject) {
                        var _a;
                        var videoID = videoObject.snippet.resourceId.videoId;
                        if (typeof videoID !== "string")
                            return [];
                        var container = document.createElement("section");
                        (_a = container.classList).add.apply(_a, __spreadArray(__spreadArray([], __read(itemBem.classes), false), __read(BEM.pageContent({ "major-column": "left" }).classes), false));
                        container.innerHTML = html(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            <div class=\"", "\">\n              <div class=\"", "\">\n                <iframe\n                  src=\"https://www.youtube.com/embed/", "\"\n                  class=\"", "\"\n                  allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\"\n                  allowfullscreen\n                  title=\"", "\"\n                  frameborder=\"0\"\n                ></iframe>\n              </div>\n            </div>\n            <div class=\"", "\">\n              <h3 class=\"", "\">", "</h3>\n              ", "\n            </div>\n          "], ["\n            <div class=\"", "\">\n              <div class=\"", "\">\n                <iframe\n                  src=\"https://www.youtube.com/embed/", "\"\n                  class=\"", "\"\n                  allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\"\n                  allowfullscreen\n                  title=\"", "\"\n                  frameborder=\"0\"\n                ></iframe>\n              </div>\n            </div>\n            <div class=\"", "\">\n              <h3 class=\"", "\">", "</h3>\n              ", "\n            </div>\n          "])), itemBem("left"), BEM.imgAspectRatio(["9-16"]), videoID, itemBem("iframe"), videoObject.snippet.title, itemBem("right"), itemBem("title"), videoObject.snippet.title, videoObject.snippet.description
                            ? html(templateObject_2 || (templateObject_2 = __makeTemplateObject(["<p class=\"", "\">\n                    ", "\n                  </p>"], ["<p class=\"", "\">\n                    ", "\n                  </p>"])), itemBem("description"), videoObject.snippet.description) : "");
                        return [container];
                    })];
            });
        }); })
            .then(function (videoElements) {
            var e_2, _a, e_3, _b;
            if (videoElements.length === 0) {
                // Add an empty modifier.
                widgetBem.modify({ empty: true, filled: false });
                try {
                    for (var widgetContainers_2 = __values(widgetContainers), widgetContainers_2_1 = widgetContainers_2.next(); !widgetContainers_2_1.done; widgetContainers_2_1 = widgetContainers_2.next()) {
                        var container = widgetContainers_2_1.value;
                        // Write a message to let the user know it is empty.
                        container.innerHTML = html(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n              <div class=\"", "\">\n                No videos found. Check back later for more!\n              </div>\n            "], ["\n              <div class=\"", "\">\n                No videos found. Check back later for more!\n              </div>\n            "])), widgetBem("no-videos"));
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (widgetContainers_2_1 && !widgetContainers_2_1.done && (_a = widgetContainers_2.return)) _a.call(widgetContainers_2);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
                return [];
            }
            var elementClones = Array.from({
                length: widgetContainers.length,
            });
            elementClones[0] = videoElements;
            for (var i = 1; i < widgetContainers.length; i++) {
                elementClones[i] = Array.from({
                    length: videoElements.length,
                });
                for (var j = 0; j < videoElements.length; j++) {
                    elementClones[i][j] = videoElements[j].cloneNode(true);
                }
            }
            // Add a class indicating that the widget has content.
            widgetBem.modify({ empty: false, filled: true });
            for (var i = 0; i < widgetContainers.length; i++) {
                // Clear the widget container's children.
                widgetContainers[i].textContent = "";
                try {
                    // Insert each event one-by-one.
                    for (var _c = (e_3 = void 0, __values(elementClones[i])), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var element = _d.value;
                        widgetContainers[i].appendChild(element);
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
            }
            widgetBem.modify({ state: "loaded" });
        })
            .catch(function () {
            var div = document.createElement("div");
            div.classList.add(widgetBem("errored").className);
            div.innerHTML = html(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n          <div>There was a problem getting the YouTube videos.</div>\n          <button\n            class=\"", "\"\n          >\n            Try again\n          </button>\n        "], ["\n          <div>There was a problem getting the YouTube videos.</div>\n          <button\n            class=\"", "\"\n          >\n            Try again\n          </button>\n        "])), BEM.button({
                bg: "primary",
                text: "lightest",
                hover: "shadow",
            }));
            widgetBem.modify({ state: "errored" });
            for (var i = 0; i < widgetContainers.length; i++) {
                // Clear the widget container's children.
                widgetContainers[i].textContent = "";
                var clone = div.cloneNode(true);
                var button = clone.querySelector("button");
                button.addEventListener("click", fetchYoutubeFeed);
                widgetContainers[i].appendChild(clone);
            }
        });
    };
    fetchYoutubeFeed();
};
export default createWidgets;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
